// services/RequestCancellationService.ts
class RequestCancellationService {
  private static instance: RequestCancellationService;
  private activeRequests: Map<string, AbortController> = new Map();

  private constructor() {}

  public static getInstance(): RequestCancellationService {
    if (!RequestCancellationService.instance) {
      RequestCancellationService.instance = new RequestCancellationService();
    }
    return RequestCancellationService.instance;
  }

  public cancelRequest(requestKey: string): void {
    const existingController = this.activeRequests.get(requestKey);
    if (existingController) {
      existingController.abort();
      this.activeRequests.delete(requestKey);
    }
  }

  public addRequest(requestKey: string, controller: AbortController): void {
    // Cancel existing request first
    this.cancelRequest(requestKey);
    // Add new controller
    this.activeRequests.set(requestKey, controller);
  }

  public removeRequest(requestKey: string): void {
    this.activeRequests.delete(requestKey);
  }

  public cancelAllRequests(): void {
    this.activeRequests.forEach((controller) => {
      controller.abort();
    });
    this.activeRequests.clear();
  }

  // Optional: Get active request count for debugging
  public getActiveRequestCount(): number {
    return this.activeRequests.size;
  }

  // Optional: Check if a specific request is active
  public isRequestActive(requestKey: string): boolean {
    return this.activeRequests.has(requestKey);
  }
}

export default RequestCancellationService;
